import React from "react";
import Sidebar from "../components/Sidebar";

const Monitor: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">ตรวจสอบระบบ</h1>
          <p className="text-gray-600 mb-6">ตรวจสอบสถานะและประสิทธิภาพของระบบ</p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">สถานะเซิร์ฟเวอร์</p>
              <p className="text-2xl font-bold text-green-600">ปกติ</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">อัปเวลา</p>
              <p className="text-2xl font-bold text-green-600">99.9%</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">เวลาตอบสนอง</p>
              <p className="text-2xl font-bold text-blue-600">45ms</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">คำขอต่อวินาที</p>
              <p className="text-2xl font-bold text-purple-600">127</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">การใช้งาน CPU</h2>
              <div className="h-48 bg-gray-50 rounded-lg flex items-center justify-center">
                <p className="text-gray-500">กราฟการใช้งาน CPU</p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">การใช้งานหน่วยความจำ</h2>
              <div className="h-48 bg-gray-50 rounded-lg flex items-center justify-center">
                <p className="text-gray-500">กราฟการใช้งานหน่วยความจำ</p>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">บันทึกเซิร์ฟเวอร์</h2>
            <div className="space-y-2 font-mono text-sm">
              <div className="bg-gray-50 p-2 rounded">
                <span className="text-green-600">[2026-04-21 23:30:00]</span> Server started successfully
              </div>
              <div className="bg-gray-50 p-2 rounded">
                <span className="text-blue-600">[2026-04-21 23:31:00]</span> Database connection established
              </div>
              <div className="bg-gray-50 p-2 rounded">
                <span className="text-blue-600">[2026-04-21 23:32:00]</span> Cache initialized
              </div>
              <div className="bg-gray-50 p-2 rounded">
                <span className="text-green-600">[2026-04-21 23:33:00]</span> All services running normally
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Monitor;
